export enum CategoryTypeEnum {
  pessoa= 'PEOPLE',
  documento = 'DOCUMENT',
  veiculo = 'VEHICLE',
  diversos = 'OTHER'
}
